export const parlayTypeOptions = [
  { name: 'All parlay types', value: 'all' },
  { name: 'Parlay 2', value: 2 },
  { name: 'Parlay 3', value: 3 },
  { name: 'Parlay 4', value: 4 },
  { name: 'Parlay 5', value: 5 },
  { name: 'Parlay 6', value: 6 },
  { name: 'Parlay 7', value: 7 },
  { name: 'Parlay 8', value: 8 },
  { name: 'Parlay 9', value: 9 },
  { name: 'Parlay 10', value: 10 },
  { name: 'Parlay 11', value: 11 },
  { name: 'Parlay 12', value: 12 },
]

export const parlayVoucherFeed = [
  {
    id: 'MP-241016-001',
    createdAt: '2025-10-16T11:45:00Z',
    customerName: 'Stephanie Bloom',
    username: 'stephb',
    parlaySize: 6,
    stake: 420,
    potential: 6430,
    selections: [
      { market: 'Soccer - EPL', pick: 'Over 2.5', odds: 1.85 },
      { market: 'Basketball - NBA', pick: 'Home -4.5', odds: 1.92 },
    ],
  },
  {
    id: 'MP-241016-002',
    createdAt: '2025-10-16T12:01:00Z',
    customerName: 'Riley Chen',
    username: 'ric77',
    parlaySize: 4,
    stake: 150,
    potential: 1780,
    selections: [
      { market: 'Tennis - ATP', pick: 'Player A', odds: 1.65 },
      { market: 'Soccer - UCL', pick: 'Away ML', odds: 2.1 },
    ],
  },
  {
    id: 'MP-241016-003',
    createdAt: '2025-10-16T12:24:00Z',
    customerName: 'Jamal Turner',
    username: 'jturn89',
    parlaySize: 8,
    stake: 90,
    potential: 8140,
    selections: [
      { market: 'Soccer - La Liga', pick: 'Home ML', odds: 1.7 },
      { market: 'Esports - LoL', pick: 'Map 1 - Over 28.5', odds: 1.96 },
    ],
  },
  {
    id: 'MP-241016-004',
    createdAt: '2025-10-16T12:40:00Z',
    customerName: 'Kim Nguyen',
    username: 'kimn',
    parlaySize: 12,
    stake: 45,
    potential: 12450,
    selections: [
      { market: 'Soccer - Serie A', pick: 'Both teams score', odds: 1.8 },
      { market: 'Baseball - MLB', pick: 'Over 7.5', odds: 1.9 },
    ],
  },
  {
    id: 'MP-241016-005',
    createdAt: '2025-10-16T13:05:00Z',
    customerName: 'Lara Gomez',
    username: 'larag',
    parlaySize: 3,
    stake: 220,
    potential: 1230,
    selections: [
      { market: 'Soccer - Ligue 1', pick: 'Home ML', odds: 1.68 },
      { market: 'Soccer - EPL', pick: 'Over 3.5', odds: 2.2 },
    ],
  },
  {
    id: 'MP-241016-006',
    createdAt: '2025-10-16T13:28:00Z',
    customerName: 'Noah Patel',
    username: 'np99',
    parlaySize: 5,
    stake: 375,
    potential: 5620,
    selections: [
      { market: 'Soccer - Bundesliga', pick: 'Both teams score', odds: 1.82 },
      { market: 'Cricket - T20', pick: 'Home ML', odds: 1.95 },
    ],
  },
  {
    id: 'MP-241016-007',
    createdAt: '2025-10-16T13:55:00Z',
    customerName: 'Oliver West',
    username: 'westside',
    parlaySize: 10,
    stake: 120,
    potential: 9340,
    selections: [
      { market: 'Soccer - MLS', pick: 'Over 3.5', odds: 2.05 },
      { market: 'Hockey - NHL', pick: 'Away ML', odds: 2.2 },
    ],
  },
  {
    id: 'MP-241016-008',
    createdAt: '2025-10-16T14:15:00Z',
    customerName: 'Vida Stokes',
    username: 'vidast',
    parlaySize: 2,
    stake: 500,
    potential: 1150,
    selections: [
      { market: 'Soccer - Eredivisie', pick: 'Home ML', odds: 1.6 },
      { market: 'Basketball - Euroleague', pick: 'Under 162.5', odds: 1.93 },
    ],
  },
]

export const parlayTotalsByType = parlayVoucherFeed.reduce((accumulator, voucher) => {
  const key = `Parlay ${voucher.parlaySize}`
  const existing = accumulator.get(key) ?? { type: key, vouchers: 0, totalStake: 0, totalPotential: 0 }
  const next = {
    ...existing,
    vouchers: existing.vouchers + 1,
    totalStake: existing.totalStake + voucher.stake,
    totalPotential: existing.totalPotential + voucher.potential,
  }
  accumulator.set(key, next)
  return accumulator
}, new Map())

export const parlayEnhancementIdeas = [
  'Auto-flag combinations that reuse the same leg across multiple customers.',
  'Surface hedging recommendations when potential payout exceeds configured limits.',
  'Link each voucher to live event probabilities so risk teams can compare real-time win chances.',
]

